import { spaceApiUtilitarios } from "../clienteSpace";
import type {
	ICfgClassificacaoGrupoResponse,
	CfgParametrosGeraisResposta,
	NomeParametroGeral,
	IListarMeiosPagamentoRequest,
	IListarContasBaixaPagarRequest,
	IContaBaixaPagarItem,
	IMeioPagamentoResponse,
} from "../dtos/utilitarios-service.dto";

// --------------------------------- TYPES ---------------------------------
type ListarCfgParametrosGeraisOptions = {
	readonly nomeParametro?: NomeParametroGeral;
	readonly signal?: AbortSignal;
};

// ------------------------------- FUNCTIONS -------------------------------
export function listarCfgParametrosGerais({
	nomeParametro,
	signal,
}: Readonly<ListarCfgParametrosGeraisOptions> = {}): Promise<CfgParametrosGeraisResposta> {
	const searchParams = nomeParametro ? { nome_parametro: nomeParametro } : undefined;
	return spaceApiUtilitarios
		.get("cfg-parametros-gerais/listar", { searchParams, signal })
		.json<CfgParametrosGeraisResposta>();
}

export async function getCfgClassificacoes(descricaoTipo: string, descricaoGrupo?: string, signal?: AbortSignal) {
	const searchParams = new URLSearchParams({ descricao_tipo: descricaoTipo });
	if (descricaoGrupo) searchParams.set("descricao_grupo", descricaoGrupo);

	return spaceApiUtilitarios
		.get("cfg-classificacao/listar", { searchParams, signal })
		.json<ICfgClassificacaoGrupoResponse[]>();
}

export async function getMeiosPagamento(params: IListarMeiosPagamentoRequest, signal?: AbortSignal) {
	const searchParams = new URLSearchParams();

	for (const [chave, valor] of Object.entries(params))
		if (valor !== undefined) searchParams.set(chave, String(valor));

	return spaceApiUtilitarios.get("meio-pagamento/listar", { searchParams, signal }).json<IMeioPagamentoResponse[]>();
}

export async function listarContasBaixaPagar(params: IListarContasBaixaPagarRequest, signal?: AbortSignal) {
	return spaceApiUtilitarios
		.get("conta-bancaria-baixa-pagar/listar", { searchParams: params, signal })
		.json<IContaBaixaPagarItem[]>();
}
